import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { motion } from 'framer-motion';
import { observer } from 'mobx-react';
import { forwardRef, useContext } from 'react';
import { useAnimationConfig } from '../../../../../context/occ/hooks/use-animation-config';
import { useOccContext } from '../../../../../context/occ/hooks/use-occ-context';
import { Message } from '../../../../message/message';
import { ModalHeader } from '../../../../modal/subcomponents/header';
import { DropdownContextInstance } from '../types/context';
import { DropdownList, getNoSearchResultsFoundMessage } from './list';
import { DropdownSearchInput } from './search-input';
const b = bemClassBuilder('v-dropdown-content');
var AnimationType;
(function (AnimationType) {
    AnimationType["Visible"] = "visible";
    AnimationType["Hidden"] = "hidden";
})(AnimationType || (AnimationType = {}));
export const DropdownContentBase = (props, ref) => {
    const { i18n, displayText: occDisplayText } = useOccContext();
    const { heading, searchInputPlaceholder, errorTitle, errorMessage, errorIconName } = props;
    const { showModalErrorMessage, displayAsModalOnMobile, isDropdownExpanded, showSearch, searchTerm, toggleDropdown } = useContext(DropdownContextInstance);
    const hasError = !!errorTitle || !!errorMessage || !!errorIconName;
    const showSearchInModal = showSearch && displayAsModalOnMobile && !hasError;
    const { enableAnimations } = useAnimationConfig();
    const animations = {
        [AnimationType.Visible]: {
            opacity: 1,
            y: 0,
            transition: {
                type: 'tween',
                opacity: {
                    delay: 0.1
                }
            }
        },
        [AnimationType.Hidden]: { opacity: 0, y: -35 }
    };
    return (_jsxs(motion.div, { className: b.block({ hidden: !isDropdownExpanded, showAsModal: displayAsModalOnMobile }), variants: enableAnimations ? animations : undefined, animate: isDropdownExpanded && enableAnimations ? AnimationType.Visible : AnimationType.Hidden, children: [displayAsModalOnMobile && (_jsx(ModalHeader, { className: b.element('header'), heading: heading, showCloseButton: true, onClose: toggleDropdown })), showSearchInModal && (_jsx(DropdownSearchInput, { className: b.element('search-input'), enableClearIcon: true, placeholder: searchInputPlaceholder })), showModalErrorMessage && (_jsx(Message, { className: b.element('message', { showTopBorder: !showSearchInModal }), title: errorTitle, description: hasError
                    ? errorMessage
                    : getNoSearchResultsFoundMessage(props.noSearchResultsFoundMessage || occDisplayText.noSearchResultsFoundMessage, i18n, searchTerm), iconName: hasError ? errorIconName : props.noSearchResultsFoundIconName })), _jsx(DropdownList, { ref: ref })] }));
};
export const DropdownContent = observer(forwardRef(DropdownContentBase));
DropdownContent.displayName = 'DropdownContent';
//# sourceMappingURL=content.js.map